"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.printWarningWithTrace = void 0;
var printWarningWithTrace = function(message) {
    return(// eslint-disable-next-line no-console -- appropriate here
    console.trace("☢️ WARNING:\n".concat(message)));
};
exports.printWarningWithTrace = printWarningWithTrace; //# sourceMappingURL=printWarningWithTrace.js.map
